import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import Immutable from 'immutable';
import Post, { fillDetails } from './models/post';
import { showModal, hideModal, updateWheel } from './actions';
import ModalRoot from './components/ModalRoot';

class App extends Component {
  constructor() {
    super();
    this.scrollListener = throttle(this.scrollListener.bind(this), 300);
    this.calculateTopPosition = this.calculateTopPosition.bind(this);
    this.sid = null;
  }

  componentDidMount() {
    this.sid = setInterval(() => {
      if (window.Kakao) {
        clearInterval(this.sid);
        window.Kakao.init(process.env.REACT_APP_KAKAO_KEY);
      }
    }, 500);
    this.attachScrollListener();
  }

  componentWillUnmount() {
    this.detachScrollListener();
  }

  attachScrollListener() {
    let scrollEl = window;
    scrollEl.addEventListener('scroll', this.scrollListener);
    scrollEl.addEventListener('resize', this.scrollListener);
  }

  detachScrollListener() {
    let scrollEl = window;
    scrollEl.removeEventListener('scroll', this.scrollListener);
    scrollEl.removeEventListener('resize', this.scrollListener);
  }

  calculateTopPosition(el) {
    if(!el) {
      return 0;
    }
    return el.offsetTop + this.calculateTopPosition(el.offsetParent);
  }

  scrollListener(e) {
    const scrollEl = window;
    const scrollTop = (scrollEl.pageYOffset !== undefined) ? scrollEl.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    this.props.updateWheel(scrollTop);
  }

  render() {
    const { post, modal: { modalType, modalProps }, showModal, hideModal, device,
      ariaHiddenKakaoIndex } = this.props;
    return (
      <div style={{ height: '100%' }}>
        {ariaHiddenKakaoIndex ? (
          <div id="kakaoIndex"></div>
        ) : (
          <div id="kakaoIndex">
            <a href="#kakaoBody">본문 바로가기</a>
            <a href="#kakaoGnb">메뉴 바로가기</a>
          </div>
        )}
        <div id="kakaoWrap">
          { this.props.router }
        </div>
        <hr className="hide" />
        <ModalRoot 
          modalType={modalType} 
          modalProps={modalProps}
          showModal={showModal}
          hideModal={hideModal}
        />
        <div id="socialShareLayer"></div>
      </div>
    );
  }
}

export default connect(
  ({ modal, post: postId, entities, device, appdata }) => {
    const p = entities.getIn(['posts', `${postId}`]);
    const post = p ? fillDetails(
      new Post(p),
      entities
    ) : null;
    const ariaHiddenKakaoIndex = (appdata || Immutable.Map()).get('ariaHiddenKakaoIndex', false);
    return { post, modal, device, ariaHiddenKakaoIndex };
  },
  (dispatch) => bindActionCreators({ showModal, hideModal, updateWheel }, dispatch)
)(App);



// WEBPACK FOOTER //
// ./src/App.js